__turbopack_context__.v({
  "address": "PageRenderer-module__WaX4Ia__address",
  "alignCenter": "PageRenderer-module__WaX4Ia__alignCenter",
  "alignRight": "PageRenderer-module__WaX4Ia__alignRight",
  "backLink": "PageRenderer-module__WaX4Ia__backLink",
  "block": "PageRenderer-module__WaX4Ia__block",
  "blockLink": "PageRenderer-module__WaX4Ia__blockLink",
  "blockLinkArrow": "PageRenderer-module__WaX4Ia__blockLinkArrow",
  "bookingIntro": "PageRenderer-module__WaX4Ia__bookingIntro",
  "button": "PageRenderer-module__WaX4Ia__button",
  "buttonRow": "PageRenderer-module__WaX4Ia__buttonRow",
  "center": "PageRenderer-module__WaX4Ia__center",
  "column": "PageRenderer-module__WaX4Ia__column",
  "cta": "PageRenderer-module__WaX4Ia__cta",
  "dragHandle": "PageRenderer-module__WaX4Ia__dragHandle",
  "dragging": "PageRenderer-module__WaX4Ia__dragging",
  "editable": "PageRenderer-module__WaX4Ia__editable",
  "embed": "PageRenderer-module__WaX4Ia__embed",
  "fadeSection": "PageRenderer-module__WaX4Ia__fadeSection",
  "faq": "PageRenderer-module__WaX4Ia__faq",
  "faqAnswer": "PageRenderer-module__WaX4Ia__faqAnswer",
  "featured": "PageRenderer-module__WaX4Ia__featured",
  "figure": "PageRenderer-module__WaX4Ia__figure",
  "full": "PageRenderer-module__WaX4Ia__full",
  "gallery": "PageRenderer-module__WaX4Ia__gallery",
  "galleryImage": "PageRenderer-module__WaX4Ia__galleryImage",
  "heading": "PageRenderer-module__WaX4Ia__heading",
  "hero": "PageRenderer-module__WaX4Ia__hero",
  "heroContent": "PageRenderer-module__WaX4Ia__heroContent",
  "heroHasImage": "PageRenderer-module__WaX4Ia__heroHasImage",
  "heroImage": "PageRenderer-module__WaX4Ia__heroImage",
  "heroOverlay": "PageRenderer-module__WaX4Ia__heroOverlay",
  "heroRise": "PageRenderer-module__WaX4Ia__heroRise",
  "hr": "PageRenderer-module__WaX4Ia__hr",
  "image": "PageRenderer-module__WaX4Ia__image",
  "inView": "PageRenderer-module__WaX4Ia__inView",
  "inlineArea": "PageRenderer-module__WaX4Ia__inlineArea",
  "inlineInput": "PageRenderer-module__WaX4Ia__inlineInput",
  "kenburns": "PageRenderer-module__WaX4Ia__kenburns",
  "left": "PageRenderer-module__WaX4Ia__left",
  "linkIcon": "PageRenderer-module__WaX4Ia__linkIcon",
  "linkList": "PageRenderer-module__WaX4Ia__linkList",
  "linkListInline": "PageRenderer-module__WaX4Ia__linkListInline",
  "map": "PageRenderer-module__WaX4Ia__map",
  "ornament": "PageRenderer-module__WaX4Ia__ornament",
  "page": "PageRenderer-module__WaX4Ia__page",
  "placeholder": "PageRenderer-module__WaX4Ia__placeholder",
  "previewBlock": "PageRenderer-module__WaX4Ia__previewBlock",
  "priceActions": "PageRenderer-module__WaX4Ia__priceActions",
  "priceCard": "PageRenderer-module__WaX4Ia__priceCard",
  "priceDesc": "PageRenderer-module__WaX4Ia__priceDesc",
  "priceGrid": "PageRenderer-module__WaX4Ia__priceGrid",
  "priceInfo": "PageRenderer-module__WaX4Ia__priceInfo",
  "priceLeader": "PageRenderer-module__WaX4Ia__priceLeader",
  "priceList": "PageRenderer-module__WaX4Ia__priceList",
  "priceName": "PageRenderer-module__WaX4Ia__priceName",
  "priceRow": "PageRenderer-module__WaX4Ia__priceRow",
  "priceRowDesc": "PageRenderer-module__WaX4Ia__priceRowDesc",
  "priceRowName": "PageRenderer-module__WaX4Ia__priceRowName",
  "priceTable": "PageRenderer-module__WaX4Ia__priceTable",
  "priceTableBook": "PageRenderer-module__WaX4Ia__priceTableBook",
  "priceTableDesc": "PageRenderer-module__WaX4Ia__priceTableDesc",
  "priceTableName": "PageRenderer-module__WaX4Ia__priceTableName",
  "priceTablePrice": "PageRenderer-module__WaX4Ia__priceTablePrice",
  "priceValue": "PageRenderer-module__WaX4Ia__priceValue",
  "right": "PageRenderer-module__WaX4Ia__right",
  "scrollTop": "PageRenderer-module__WaX4Ia__scrollTop",
  "section": "PageRenderer-module__WaX4Ia__section",
  "sectionInner": "PageRenderer-module__WaX4Ia__sectionInner",
  "sectionTitle": "PageRenderer-module__WaX4Ia__sectionTitle",
  "selected": "PageRenderer-module__WaX4Ia__selected",
  "siteFooter": "PageRenderer-module__WaX4Ia__siteFooter",
  "siteFooterBrand": "PageRenderer-module__WaX4Ia__siteFooterBrand",
  "siteFooterContact": "PageRenderer-module__WaX4Ia__siteFooterContact",
  "siteFooterCopy": "PageRenderer-module__WaX4Ia__siteFooterCopy",
  "siteFooterGrid": "PageRenderer-module__WaX4Ia__siteFooterGrid",
  "siteFooterInner": "PageRenderer-module__WaX4Ia__siteFooterInner",
  "siteFooterLinks": "PageRenderer-module__WaX4Ia__siteFooterLinks",
  "siteFooterTagline": "PageRenderer-module__WaX4Ia__siteFooterTagline",
  "slideFade": "PageRenderer-module__WaX4Ia__slideFade",
  "slider": "PageRenderer-module__WaX4Ia__slider",
  "sliderArrow": "PageRenderer-module__WaX4Ia__sliderArrow",
  "sliderContent": "PageRenderer-module__WaX4Ia__sliderContent",
  "sliderDot": "PageRenderer-module__WaX4Ia__sliderDot",
  "sliderDotActive": "PageRenderer-module__WaX4Ia__sliderDotActive",
  "sliderDots": "PageRenderer-module__WaX4Ia__sliderDots",
  "sliderNext": "PageRenderer-module__WaX4Ia__sliderNext",
  "sliderPrev": "PageRenderer-module__WaX4Ia__sliderPrev",
  "testimonial": "PageRenderer-module__WaX4Ia__testimonial",
  "testimonialGrid": "PageRenderer-module__WaX4Ia__testimonialGrid",
  "text": "PageRenderer-module__WaX4Ia__text",
  "video": "PageRenderer-module__WaX4Ia__video",
});
